/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from "react";
import useAPIHandler from "../hook/use-api-handler";

const AuthContext = createContext(null);

export function AuthContextProvider({ children }) {
  const [user, setUser] = useState();
  const token = localStorage.getItem("hrms_token");

  const [getProfileLoading, setgetProfileLoading] = useState(false);
  const [authLoading, setauthLoading] = useState(true);
  const [orgDetails, setOrgDetails] = useState({});
  const [orgConfigationDetails, setConfigationOrgDetails] = useState({});
  const [authInfo, setauthInfo] = useState({});
  const [signinEmail, setSigninEmail] = useState(null);
  const { fetchData } = useAPIHandler();

  const [isNotMount, setIsNotMount] = useState(true);

  async function getOrganizationFn({ customToken } = {}) {
    try {
      setgetProfileLoading(true);
      const payload = { url: "/organization/organization-basic-information" };
      if (customToken) {
        payload.customToken = customToken;
      }
      const basicOrganizationPromise = fetchData(payload);
      basicOrganizationPromise
        .then((res) => {
          setOrgDetails(res?.data);

          setgetProfileLoading(false);
        })
        .catch((err) => {
          setgetProfileLoading(false);
        });
      return basicOrganizationPromise;
    } catch (error) {
      setgetProfileLoading(false);
    }
  }

  async function authFn() {
    try {
      setauthLoading(true);
      const payload = { url: "/auth" };

      const basicOrganizationPromise = fetchData(payload);
      basicOrganizationPromise
        .then((res) => {
          setauthInfo(res?.data);
          getOrganizationFn();
          setauthLoading(false);
        })
        .catch((err) => {
          localStorage.removeItem("hrms_token");
          localStorage.removeItem("hrms_admin_token");
          setauthLoading(false);
        });
      return basicOrganizationPromise;
    } catch (error) {
      localStorage.removeItem("hrms_token");
      localStorage.removeItem("hrms_admin_token");
      setauthLoading(false);
    }
  }

  useEffect(() => {
    setIsNotMount(false);
  }, []);

  useEffect(() => {
    if (token && !isNotMount) {
      authFn();
    }
  }, [isNotMount, token]);

  useEffect(() => {
    if (isNotMount) {
      const localtoken = localStorage.getItem("hrms_token");
      if (!localtoken) {
        setauthLoading(false);
      }
    }
  }, [isNotMount]);

  const value = {
    token,
    user,
    setUser,
    orgDetails,
    getProfileLoading,
    getOrganizationFn,
    authLoading,
    setauthLoading,
    authInfo,
    authFn,
    setSigninEmail,
    signinEmail,
    isNotMount,
    setIsNotMount,
    orgConfigationDetails
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuthContext = () => useContext(AuthContext);
